import {Constants} from "../../constants";

export function testPassStrength(password: string): number {
  if (password.length >= Constants.strongPassLength){
    return 2
  }
  if (password.length >= Constants.mediumPassLength) {
    return 1
  }
  return 0;
}
